module.exports = {
    dateFormat: 'dd/mmm HH:MM:ss.l',
    lineNotifyUrl: 'http://linenotify.realtime.co.th',
    tokens: [
        'z3EQtjq9OI5Xw5tCGI91RW3mtfFiFk3pc515plTYQSt', // rongtium
        // 'Sm9mG5pj6rzLcFzNi3C8gEFAhFNCf6fD5eyvXbSdYFa' // family
    ]
};